// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ActionIcon_wrapper__2SWSW","icon":"ActionIcon_icon__3jNvx","tooltipContainer":"ActionIcon_tooltipContainer__1wTLZ","rotate":"ActionIcon_rotate__3gSx3"};